<template>
  <div class="expert-score">
    <div class="container-fluid">
      <div class="wrapper">
        <div class="content-page">
          <div class="content">
            <div class="row mb-1">
              <div class="col-xl-6">专家评分</div>
              <div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;">
                <Breadcrumb></Breadcrumb>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="tab_box mb-3" v-if="tabList.length">
                  <div class="tab_item" :class="tabsActive==item.id?'active':''" v-for="item in tabList" :key="item.id" @click="handleTabChange(item.id)">{{item.title}}</div>
                </div>
                <el-table :header-cell-style="tableHeaderStyle" ref="multipleTable" :data="list" tooltip-effect="light" style="width: 100%" border>
                  <el-table-column prop="projectName" label="申报项目" min-width="150">
                    <template slot-scope="scope">
                      <span class="project_name" @click="toReview(scope.row)">{{scope.row.projectName}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="toReviewDeclareNumber" label="待评课题数" min-width="80"></el-table-column>
                  <el-table-column prop="hasReviewDeclareNumber" label="已评数量" min-width="80"></el-table-column>
                  <el-table-column prop="residueDeclareNumber" label="剩余数量" min-width="80"></el-table-column>
                  <el-table-column prop="isSubmit" label="是否提交" min-width="100">
                    <template slot-scope="scope">
                      <span>{{scope.row.isSubmit===0?'未提交':'已提交'}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="reviewStartTime" label="开始时间" min-width="120">
										<template v-slot="scope">
											{{scope.row.reviewStartTime|getTime}}
										</template>
									</el-table-column>
                  <el-table-column prop="reviewEndTime" label="预计结束时间" min-width="120">
										<template v-slot="scope">
											{{scope.row.reviewEndTime|getTime}}
										</template>
									</el-table-column>
                  <el-table-column label="操作" min-width="100">
                    <template slot-scope="scope">
                      <el-button type="primary" size="small" @click="toReview(scope.row)">进入评审</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <!-- 分页器 -->
                <div class="text-right mt-2">
                  <el-pagination layout="total, sizes, prev, pager, next, jumper" background :current-page="query.pageNumber" :page-sizes="[20, 50, 100, 200]" :page-size="query.pageSize" :total="total" @size-change="handleSizeChange" @current-change="handlePageChange"></el-pagination>
                </div>
              </div> <!-- end card-body-->
            </div> <!-- end card -->
          </div> <!-- end col-->
        </div>

      </div>
      <!-- end wrapper-->
    </div>
  </div>
</template>

<script>
import {
  getExpertScoreProjectList,
  getProjectIdByQualification,
} from "@/api/after/expertScore";
import Breadcrumb from "@/views/backstage/components/Breadcrumb.vue";
export default {
  name: "expertScoreList",
  components: { Breadcrumb },
  data() {
    return {
      tableHeaderStyle: { backgroundColor: "#7e9be2", color: "#fff" },
      tabList: [
        { id: 0, title: "申报初评" },
        { id: 1, title: "申报复评" },
        { id: 2, title: "申报终评" },
      ],
      projectData: {},
      tabsActive: 0,
      list: [],
      total: 0,
      query: {
        projectId:0,
        reviewType: 0,
        userId: "",
        pageNumber: 1,
        pageSize: 20,
        pageSorts: [{ asc: true, column: "" }],
      },
    };
  },
  mounted() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.query.userId = userInfo.id;
    let projectData = sessionStorage.getItem("projectData");
    if (projectData) {
      projectData = JSON.parse(projectData);
      this.query.projectId=projectData.id
      this.getProjectIdByQualification(projectData.id);
    }
  },
  methods: {
    // 获取数据列表
    getData(isNum) {
      if (isNum) this.query.pageNumber = 1;
      getExpertScoreProjectList(this.query).then((res) => {
        if (res.code == 200) {
          this.list = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.data);
        }
      });
    },
    getProjectIdByQualification(id) {
      getProjectIdByQualification(id).then((res) => {
        if (res.code == 200) {
          let data = res.data;
          this.tabList = this.tabList.filter((item) => {
            return (
              (item.id == 0 && data.internState) ||
              (item.id == 1 && data.reviewState) ||
              (item.id == 2 && data.finalState)
            );
          });
          if (this.tabList.length > 0) {
            this.query.reviewType = this.tabList[0].id;
            this.getData();
          }
        } else {
          this.$message.error(res.data);
        }
      });
    },
    handleTabChange(num) {
      this.query.reviewType = num;
      this.tabsActive = num;
      this.getData(true);
    },
    toReview(data) {
      this.$router.push({
        path: "/backstage/notReviewTopics",
        query: { data: JSON.stringify(data) },
      });
    },
    // 分页导航
    handlePageChange(val) {
      this.query.pageNumber = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getData(true);
    },
  },
};
</script>

<style scoped>
.tab_box {
  border-bottom: 2px solid #56acf5;
  display: flex;
}
.tab_box .tab_item {
  padding: 0 20px;
  height: 40px;
  box-sizing: border-box;
  line-height: 40px;
  display: inline-block;
  list-style: none;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  border: 1px solid rgb(223, 223, 223);
  border-bottom: none;
  cursor: pointer;
}
.tab_box .tab_item.active {
  color: #fff;
  background: #56acf5;
  border-left: none;
  border-color: #56acf5;
}
/deep/.el-table th > .cell {
  text-align: center;
}

/deep/.el-table .cell {
  text-align: center;
}
/deep/.el-tabs__item.is-active {
  color: #fff;
  background: #56acf5;
}
/deep/.el-tabs--card > .el-tabs__header {
  border-bottom: 2px solid #56acf5;
}
.project_name {
  color: #56acf5;
  cursor: pointer;
}
</style>